// extracted by css-extract-rspack-plugin
export default {"sidebarToggleButton":"ListSidebar-module__sidebarToggleButton__O3z5g","sidebarHeading":"ListSidebar-module__sidebarHeading__zi9Fh","dialog":"ListSidebar-module__dialog__LZAcx"};